import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CustomFriendsState, FRIENDS_FEATURE, StateWithFriends } from '../../../store/custom-friends-checkout.state';



export const getFriendsState: MemoizedSelector<StateWithFriends,
CustomFriendsState
> = createFeatureSelector<CustomFriendsState>(FRIENDS_FEATURE);
